import { PublishedFileDeleteDialog } from "@/action-dialog/dialogs/PublishedFileDeleteDialog";
import { createCallable } from "react-call";
import { useMutationFlow, type MutationFn } from "react-call/mutation-flow";

const UNMOUNTING_DELAY_MS = 200;

export type PublishedFileDeleteCallableProps = {
  mutationFn?: MutationFn<boolean, void>;
};

export const PublishedFileDeleteCallable = createCallable<
  PublishedFileDeleteCallableProps,
  boolean
>(({ call, mutationFn }) => {
  const submit = useMutationFlow(call, mutationFn);
  const pending = submit.pending;

  return (
    <PublishedFileDeleteDialog
      open
      isWorking={pending}
      onOpenChange={(open) => {
        if (!open && !pending) {
          call.end(false);
        }
      }}
      onConfirm={() => submit().orEnd(true)}
    />
  );
}, UNMOUNTING_DELAY_MS);

PublishedFileDeleteCallable.displayName = "PublishedFileDeleteCallable";
